import { Component } from '@angular/core';

@Component({
	selector: 'seira-monitoramento',
	templateUrl: './monitoramento.component.html',
	styleUrls: ['./monitoramento.component.scss'],
})
export class MonitoramentoComponent {}
